import { isEmpty } from 'lodash-es'
import { ComponentProps, useEffect } from 'react'
import hash from 'stable-hash'

import { MapShape } from '@/feature/map'
import { MARKER_STATIONARY_COLOR } from '@/feature/observatory'

export type RouteLayerProps = {
  points: (google.maps.LatLngLiteral | google.maps.LatLng)[]
  zIndex?: number
  colour?: string
  width?: number
  geodesic?: boolean
}
export const RouteLayer = ({
  points,
  zIndex,
  colour = '#FFF',
  width = 8,
  geodesic = true,
}: RouteLayerProps) => {
  return (
    <MapShape
      shape={window.google.maps.Polyline}
      parameters={{
        geodesic,
        path: points,
        strokeColor: colour,
        strokeWeight: width,
        zIndex,
      }}
    />
  )
}

export type RouteLayerItem = Partial<Omit<ComponentProps<typeof RouteLayer>, 'points'>>

export type RouteProps = {
  route?: (google.maps.LatLngLiteral | google.maps.LatLng)[]
  layers: Array<RouteLayerItem>
}

export const Route = ({
  route = [],
  layers = [
    {
      colour: '#FFF',
      width: 15,
    },
    {
      colour: MARKER_STATIONARY_COLOR,
      width: 8,
    },
  ],
}: RouteProps) => {
  useEffect(() => {
    if (isEmpty(layers)) console.warn('No layers provided')
  }, [layers])

  return (
    <>
      {!isEmpty(route) &&
        layers?.map((layer) => (
          <RouteLayer key={hash(layer)} points={route} zIndex={1} {...layer} />
        ))}
    </>
  )
}
